"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var observation_windows_1 = require("../../../common/helpers/observation-windows");
var json_1 = require("../../../common/helpers/json");
var hours_list_1 = require("../../../common/constants/hours_list");
var minutes_list_1 = require("../../../common/constants/minutes_list");
var AdminDrivesCreateController = /** @class */ (function () {
    function AdminDrivesCreateController($rootScope, $scope, $state, UserService, UsersModel, VehiclesModel, DrivesModel, SchoolsModel, FlashService, BatchCreateService, driveSession, VueStoreFactory, $q, instructors, vehicles, sessionTypes) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.UserService = UserService;
        this.UsersModel = UsersModel;
        this.VehiclesModel = VehiclesModel;
        this.DrivesModel = DrivesModel;
        this.FlashService = FlashService;
        this.BatchCreateService = BatchCreateService;
        this.VueStoreFactory = VueStoreFactory;
        driveSession.vehicle = vehicles[0];
        driveSession.instructor = instructors[0];
        this.driveSession = driveSession;
        this.instructors = instructors;
        this.vehicles = vehicles;
        this.sessiontypes = sessionTypes;
        this.driveSession.type = this.sessiontypes[0];
        if (this.driveSession.type.hidden === true) {
            this.driveSession.private = "Y";
        }
        BatchCreateService.setDrive(this.driveSession);
        this.hasSectors = false;
        this.sectorsRequired = true;
        this.driveSessionMap = {
            center: {
                lat: 0,
                lng: 0,
                zoom: 12,
            },
            location: {
                address: {
                    street: "",
                    city: "",
                    state: "",
                    zip: "",
                },
                zones: [],
            },
        };
        this.zones = [];
        this.sectors = [];
        this.policies = {};
        this.batchDupeDrive = "N";
        this.overrideInstructorSettings = "N";
        this.hoursList = hours_list_1.hours_list;
        this.minutesList = minutes_list_1.minutes_list;
        this.currentUser = UserService.getCurrentUser();
        this.loading = true;
        this.use_service_area = false;
        this.allow_students_to_schedule = false;
        this.mapView = "zone";
        this.instructorMapData = {};
        this.refreshDriveSessionVariableData =
            this.refreshDriveSessionVariableData.bind(this);
        this.handleDatepickerChange = this.handleDatepickerChange.bind(this);
        this.handleInitialUserResponse = this.handleInitialUserResponse.bind(this);
        this.formatPoliciesFromStore = this.formatPoliciesFromStore.bind(this);
        this.formatSchoolResponse = this.formatSchoolResponse.bind(this);
        this.handleOpenSlotWindowChange =
            this.handleOpenSlotWindowChange.bind(this);
        this.recomputeEnvelope();
        $rootScope.$on("MESSAGE_CLEARED", function () {
            _this.submitted = false;
        });
        // Process policies synchronously from the Vuex store (populated at admin
        // startup by admin.controller.ts configureCashier). Must run before
        // formatSchoolResponse because the school formatter depends on
        // use_service_area being set.
        this.formatPoliciesFromStore();
        // load all of the things!
        var getSchool = SchoolsModel.getSchoolByID(this.currentUser.school_id);
        var getUser = UsersModel.getUserByID(this.currentUser.id);
        SchoolsModel.getInstructorServiceAreaMap(this.currentUser.school_id).then(function (response) {
            _this.instructorMapData = response;
        });
        $q.all([getSchool, getUser]).then(function (responses) {
            _this.formatSchoolResponse(responses[0]);
            _this.handleInitialUserResponse(responses[1]);
            if (_this.auto_select_sectors === false) {
                _this.driveSession.zones = [];
                _this.driveSession.sectors = [];
            }
            // Apply session type defaults (overrides policy minimum if defined)
            _this.updateSessionTypeDefault();
        });
    }
    AdminDrivesCreateController.prototype.handleInitialUserResponse = function (response) {
        this.user = response;
        this.loading = false;
    };
    AdminDrivesCreateController.prototype.formatPoliciesFromStore = function () {
        var _this = this;
        var storePolicies = this.VueStoreFactory.state.auth.policies.policies;
        storePolicies.forEach(function (policy) {
            var policyName = policy.name;
            var policyMeta = {};
            policy.policymeta.forEach(function (meta) {
                policyMeta[meta.meta_key] = (0, json_1.isJson)(meta.meta_value)
                    ? JSON.parse(meta.meta_value)
                    : meta.meta_value;
            });
            _this.policies[policyName] = { id: policy.id, policymeta: policyMeta };
        });
        if (this.policies.drives.policymeta.minimum_session_length) {
            var dur = (0, time_1.minutesToHoursAndMinutes)(this.policies.drives.policymeta.minimum_session_length);
            this.driveSession.length.hours = dur.hours;
            this.driveSession.length.minutes = dur.minutes;
        }
        this.BatchCreateService.setDrive(this.driveSession);
        if (this.policies.drives.policymeta.use_service_area === "Y") {
            this.use_service_area = true;
        }
        else {
            this.use_service_area = false;
        }
        if (this.policies.drives.policymeta.auto_select_sectors === "Y") {
            this.auto_select_sectors = true;
        }
        else {
            this.auto_select_sectors = false;
        }
        if (this.policies.drives.policymeta.allow_students_to_schedule === true) {
            this.allow_students_to_schedule = true;
        }
        else {
            this.allow_students_to_schedule = false;
        }
        setTimeout(function () {
            _this.hasSectors = false;
        }, 300);
    };
    AdminDrivesCreateController.prototype.formatSchoolResponse = function (response) {
        var _this = this;
        var _a, _b, _c, _d;
        this.school = response;
        // When service areas are disabled, locations may have empty zones/zoneparts
        // Only filter if we're using service areas; otherwise use all locations
        var availableLocations;
        if (this.use_service_area) {
            availableLocations = response.locations.filter(function (location) {
                return location.zoneparts && location.zoneparts.length > 0;
            });
        }
        else {
            availableLocations = response.locations;
        }
        // Handle case where no locations are available
        if (availableLocations.length === 0) {
            this.driveSession.location = null;
            this.zones = [];
            this.sectors = [];
            this.driveSessionMap.center = {
                lat: ((_a = this.school.address) === null || _a === void 0 ? void 0 : _a.lat) || 0,
                lng: ((_b = this.school.address) === null || _b === void 0 ? void 0 : _b.lng) || 0,
                zoom: 12,
            };
            return;
        }
        this.driveSession.location = availableLocations[0];
        // Safely map zones and sectors
        this.zones = []
            .concat.apply([], (this.driveSession.location.zones || [])).map(function (zone) {
            return {
                id: zone.id,
                name: zone.name,
            };
        });
        this.sectors = []
            .concat.apply([], (this.driveSession.location.zoneparts || [])).map(function (sector) {
            return {
                id: sector.id,
                name: sector.name,
                zone_id: sector.zone_id,
            };
        });
        this.zones.forEach(function (zone, index) {
            _this.driveSession.zones[index] = zone;
        });
        this.sectors.forEach(function (sector, index) {
            _this.driveSession.sectors[index] = _this.sectors[index];
        });
        this.driveSessionMap.center = {
            lat: ((_c = this.school.address) === null || _c === void 0 ? void 0 : _c.lat) || 0,
            lng: ((_d = this.school.address) === null || _d === void 0 ? void 0 : _d.lng) || 0,
            zoom: 12,
        };
    };
    AdminDrivesCreateController.prototype.zoneSelected = function (zone) {
        var _this = this;
        // get array of selected zone ids
        var zoneSelected = this.driveSession.zones.filter(function (z) {
            if (z === null) {
                return false;
            }
            return z.id === zone.id;
        }).length > 0;
        if (zoneSelected) {
            // add all sectors of zone
            this.sectors.forEach(function (sector, index) {
                if (sector.zone_id === zone.id) {
                    _this.driveSession.sectors[index] = sector;
                }
            });
        }
        else {
            // remove all sectors of zone
            this.sectors.forEach(function (sector, index) {
                if (sector.zone_id === zone.id) {
                    delete _this.driveSession.sectors[index];
                }
            });
        }
    };
    AdminDrivesCreateController.prototype.sectorSelected = function (sector) {
        var _this = this;
        // is our sector selected?
        var sectorSelected = this.driveSession.sectors.filter(function (s) {
            if (s === null) {
                return false;
            }
            return s.id === sector.id;
        }).length > 0;
        if (sectorSelected) {
            // add the sector's zone
            this.zones.forEach(function (zone, index) {
                if (sector.zone_id === zone.id) {
                    _this.driveSession.zones[index] = zone;
                }
            });
        }
        else {
            // remove the sector's zone
            this.zones.forEach(function (zone, index) {
                // are there no selected sectors in this zone?
                var zoneSelected = _this.driveSession.sectors.filter(function (sector) {
                    if (sector === null) {
                        return false;
                    }
                    return sector.zone_id === zone.id;
                }).length > 0;
                // if not deselect the zone
                if (zoneSelected === false) {
                    delete _this.driveSession.zones[index];
                }
            });
        }
    };
    AdminDrivesCreateController.prototype.setDataOnDriveService = function () {
        this.BatchCreateService.setDrive(this.driveSession);
    };
    AdminDrivesCreateController.prototype.updateSessionTypeDefault = function () {
        if (this.driveSession.type.hidden === true) {
            this.driveSession.private = "Y";
        }
        else {
            this.driveSession.private = "N";
        }
        // Set duration from session type defaults
        if (this.driveSession.type.default_session_length_hours !== undefined) {
            this.driveSession.length.hours =
                this.driveSession.type.default_session_length_hours;
        }
        if (this.driveSession.type.default_session_length_minutes !== undefined) {
            this.driveSession.length.minutes =
                this.driveSession.type.default_session_length_minutes;
        }
        this.sectorsRequired =
            (this.driveSession.type.allow_custom_pickup_locations === true ||
                this.driveSession.type.allow_custom_dropoff_locations === true) &&
                this.driveSession.observation === false;
    };
    AdminDrivesCreateController.prototype.noteLengthValid = function () {
        if (typeof this.driveSession.notes === "undefined") {
            return true;
        }
        return this.driveSession.notes.length <= 500;
    };
    AdminDrivesCreateController.prototype.refreshDriveSessionVariableData = function (newValues, oldValues, scope) {
        this.sectorsRequired =
            (this.driveSession.type.allow_custom_pickup_locations === true ||
                this.driveSession.type.allow_custom_dropoff_locations === true) &&
                this.driveSession.observation === false;
        //this.clearForm();
        this.BatchCreateService.setDrive(this.driveSession);
    };
    AdminDrivesCreateController.prototype.clearForm = function () {
        this.driveSession.instructor = null;
        this.driveSession.sectors = [];
        this.driveSession.vehicle = null;
        this.hasSectors = false;
    };
    AdminDrivesCreateController.prototype.mustSelectSectors = function () {
        var hasOnlyOneSector = this.sectors.length === 1;
        var allowsCustomDropoffsOrPickups = this.driveSession.type.allow_custom_dropoff_locations === true ||
            this.driveSession.type.allow_custom_pickup_locations === true;
        var mustSelectSectors = !hasOnlyOneSector || allowsCustomDropoffsOrPickups;
        return mustSelectSectors;
    };
    AdminDrivesCreateController.prototype.updateSessionForm = function () {
        var _this = this;
        this.hasSectors = false;
        if (!this.driveSession.location) {
            this.zones = [];
            this.sectors = [];
            return;
        }
        var location = this.driveSession.location;
        var mapLocation = location;
        this.zones = [].concat.apply([], (this.driveSession.location.zones || []));
        this.zones.forEach(function (zone, index) {
            _this.driveSession.zones[index] = zone;
        });
        this.sectors = [].concat.apply([], (this.driveSession.location.zoneparts || []));
        this.sectors.forEach(function (sector, index) {
            _this.driveSession.sectors[index] = _this.sectors[index];
        });
        this.driveSessionMap.location = {
            address: mapLocation.address,
            zones: mapLocation.zones || [],
        };
    };
    AdminDrivesCreateController.prototype.checkSelect = function () {
        var _this = this;
        if (this.sectorsRequired === false ||
            this.sectors.length === 1 ||
            this.mustSelectSectors() === false) {
            this.hasSectors = true;
            return true;
        }
        this.hasSectors = false;
        if (typeof this.driveSession.sectors === "undefined") {
            return false;
        }
        this.driveSession.sectors.forEach(function (sector) {
            if (sector) {
                _this.hasSectors = true;
            }
        });
        return this.hasSectors;
    };
    AdminDrivesCreateController.prototype.updateSessionDate = function (newDate) {
        this.driveSession.date = newDate.selected[0];
        this.recomputeEnvelope();
    };
    AdminDrivesCreateController.prototype.updateSessionTime = function (newTime) {
        this.driveSession.time = newTime.selected[0];
        this.recomputeEnvelope();
    };
    AdminDrivesCreateController.prototype.handleDatepickerChange = function (newDatetime) {
        if (newDatetime.pickerType === "time") {
            this.updateSessionTime(newDatetime);
        }
        else if (newDatetime.pickerType === "date") {
            this.updateSessionDate(newDatetime);
        }
    };
    /**
     * The lesson's scheduled time window (start through start + length). Open slots
     * must fall inside it; the slot time pickers clamp against it.
     */
    AdminDrivesCreateController.prototype.currentSessionLength = function () {
        return (parseInt(this.driveSession.length.hours, 10) * 60 +
            parseInt(this.driveSession.length.minutes, 10));
    };
    AdminDrivesCreateController.prototype.envelopeStartDate = function () {
        var datePart = this.driveSession.date instanceof Date
            ? (0, time_1.toYMD)(this.driveSession.date)
            : (0, time_1.toYMD)((0, time_1.dateStringToDate)(this.driveSession.date));
        var timePart = (0, time_1.formatDateTime)(this.driveSession.time, "HH:mm:ss");
        return (0, time_1.dateTimeStringToDate)(datePart + " " + timePart);
    };
    AdminDrivesCreateController.prototype.recomputeEnvelope = function () {
        if (!this.driveSession.date || !this.driveSession.time) {
            return;
        }
        var start = this.envelopeStartDate();
        this.windowEnvelope = {
            start: start,
            end: (0, time_1.addMinutes)(start, this.currentSessionLength()),
        };
        this.reclampOpenSlots();
    };
    AdminDrivesCreateController.prototype.handleSessionLengthChange = function () {
        this.recomputeEnvelope();
    };
    /**
     * Pull every open slot back inside the (possibly changed) lesson envelope,
     * flagging any that had to move so the form can surface a notice.
     */
    AdminDrivesCreateController.prototype.reclampOpenSlots = function () {
        var _this = this;
        if (!this.driveSession.openSlots || !this.windowEnvelope) {
            return;
        }
        this.driveSession.openSlots.forEach(function (slot) {
            if (!slot.windowStart || !slot.windowEnd) {
                return;
            }
            var clamped = (0, observation_windows_1.clampWindow)(slot.windowStart, slot.windowEnd, _this.windowEnvelope.start, _this.windowEnvelope.end);
            slot.windowStart = clamped.start;
            slot.windowEnd = clamped.end;
            slot.windowAdjusted = clamped.clamped;
        });
    };
    AdminDrivesCreateController.prototype.addOpenSlot = function () {
        if (!this.driveSession.openSlots) {
            this.driveSession.openSlots = [];
        }
        var existing = this.driveSession.openSlots.map(function (slot) { return ({
            start: slot.windowStart,
            end: slot.windowEnd,
        }); });
        var window = (0, observation_windows_1.nextAvailableWindow)(this.windowEnvelope, existing);
        if (!window) {
            this.FlashService.setMessage({
                type: "error",
                message: "The lesson is fully covered by open slots. Shorten an existing slot to add another.",
            });
            return;
        }
        this.driveSession.openSlots.push({
            windowStart: window.start,
            windowEnd: window.end,
            windowAdjusted: false,
        });
    };
    AdminDrivesCreateController.prototype.removeOpenSlot = function (index) {
        if (!this.driveSession.openSlots) {
            return;
        }
        this.driveSession.openSlots.splice(index, 1);
    };
    AdminDrivesCreateController.prototype.handleOpenSlotWindowChange = function (change) {
        var _a;
        var slot = (_a = this.driveSession.openSlots) === null || _a === void 0 ? void 0 : _a[change.index];
        if (!slot || !change.selected || change.selected.length === 0) {
            return;
        }
        var previousStart = slot.windowStart;
        var previousEnd = slot.windowEnd;
        var timeString = (0, time_1.formatDateTime)(change.selected[0], "HH:mm:ss");
        var chosen = (0, time_1.dateTimeStringToDate)((0, time_1.toYMD)(this.windowEnvelope.start) + " " + timeString);
        var changed = change.name === "openSlotStart" ? "start" : "end";
        if (changed === "start") {
            slot.windowStart = chosen;
        }
        else {
            slot.windowEnd = chosen;
        }
        if (!slot.windowStart || !slot.windowEnd) {
            return;
        }
        var others = this.driveSession.openSlots
            .filter(function (_, index) { return index !== change.index; })
            .map(function (other) { return ({ start: other.windowStart, end: other.windowEnd }); });
        var snapped = (0, observation_windows_1.snapWindowToNeighbors)({ start: slot.windowStart, end: slot.windowEnd }, others, this.windowEnvelope, changed);
        // A non-positive window means the edit landed past a neighbor with no room;
        // reject it and keep the slot where it was.
        if (snapped.end.getTime() <= snapped.start.getTime()) {
            slot.windowStart = previousStart;
            slot.windowEnd = previousEnd;
            slot.windowAdjusted = true;
            return;
        }
        slot.windowStart = snapped.start;
        slot.windowEnd = snapped.end;
        slot.windowAdjusted = snapped.adjusted;
    };
    /**
     * Pre-fill the open-slot list with one equal slot per seat as a starting point
     * staff can tweak.
     */
    AdminDrivesCreateController.prototype.autoGenerateOpenSlots = function () {
        var _a;
        var seats = ((_a = this.driveSession.vehicle) === null || _a === void 0 ? void 0 : _a.seats) || 0;
        if (seats < 1) {
            return;
        }
        this.recomputeEnvelope();
        var placeholders = Array.from({ length: seats }, function () { return ({}); });
        var windows = (0, observation_windows_1.equalSplitWindows)(this.windowEnvelope.start, this.currentSessionLength(), placeholders);
        this.driveSession.openSlots = windows.map(function (window) { return ({
            windowStart: window.start,
            windowEnd: window.end,
            windowAdjusted: false,
        }); });
    };
    AdminDrivesCreateController.prototype.processSession = function (isValid, bookStudent) {
        var _this = this;
        this.submitted = true;
        if (this.checkSelect() === false && this.use_service_area === true) {
            this.FlashService.setMessage({
                type: "error",
                message: "You must select at least one sector.",
            });
            this.submitted = false;
            return false;
        }
        if (isValid) {
            var session = Object.assign({}, this.driveSession);
            if (session.hasOwnProperty("sectors")) {
                session.sectors = session.sectors
                    .filter(function (sector) { return sector !== null; })
                    .map(function (sector) {
                    delete sector.geom;
                    return sector;
                });
            }
            if (session.hasOwnProperty("zones")) {
                delete session.zones;
            }
            session.location = { id: session.location.id };
            session.instructor = { id: session.instructor.id };
            session.formatTime = (0, time_1.formatDateTime)(this.driveSession.time, "HH:mm:ss");
            if (this.driveSession.date instanceof Date) {
                session.formatDate = (0, time_1.toYMD)(this.driveSession.date);
            }
            else {
                session.formatDate = (0, time_1.toYMD)((0, time_1.dateStringToDate)(this.driveSession.date));
            }
            session.override_instructor_settings = this.overrideInstructorSettings;
            session.sectors = session.sectors.filter(function (sector) { return sector; });
            if (session.instructor.id === 0) {
                delete session.instructor;
            }
            if (session.vehicle.id === 0) {
                delete session.vehicle;
            }
            if (this.use_service_area === false) {
                delete session.location;
                delete session.zoneparts;
                delete session.sectors;
                delete session.zones;
            }
            if (session.observation === true && Array.isArray(session.openSlots)) {
                session.slots = session.openSlots.map(function (slot) {
                    var clamped = (0, observation_windows_1.clampWindow)(slot.windowStart || _this.windowEnvelope.start, slot.windowEnd || _this.windowEnvelope.end, _this.windowEnvelope.start, _this.windowEnvelope.end);
                    return (0, observation_windows_1.formatPivotWindow)({ start: clamped.start, end: clamped.end });
                });
            }
            delete session.openSlots;
            this.DrivesModel.createDrive(session)
                .then(function (response) {
                _this.FlashService.setMessage({
                    type: "success",
                    message: response.message,
                });
                _this.driveSession = {
                    length: { hours: 0, minutes: 0 },
                    sectors: [],
                    zones: [],
                    private: "N",
                    observation: false,
                    openSlots: [],
                };
                _this.submitted = false;
                if (bookStudent && response.drive && response.drive.id) {
                    _this.$state.go("drivecoach.admin.drives.edit", { id: response.drive.id }, { reload: true });
                }
                else {
                    _this.$state.go("drivecoach.admin.calendar", {}, { reload: true });
                }
            })
                .catch(function (Error) {
                _this.submitted = false;
            });
        }
        else {
            this.FlashService.setMessage({
                type: "error",
                message: "Please fill in the required fields.",
            });
            this.submitted = false;
        }
    };
    return AdminDrivesCreateController;
}());
AdminDrivesCreateController.$inject = [
    "$rootScope",
    "$scope",
    "$state",
    "UserService",
    "UsersModel",
    "VehiclesModel",
    "DrivesModel",
    "SchoolsModel",
    "FlashService",
    "BatchCreateService",
    "driveSession",
    "VueStoreFactory",
    "$q",
    "instructors",
    "vehicles",
    "sessionTypes",
];
exports.default = AdminDrivesCreateController;
